var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Quill from 'quill';
var embed = Quill.import('blots/embed');
var FormLinkEmbed = /** @class */ (function (_super) {
    __extends(FormLinkEmbed, _super);
    function FormLinkEmbed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormLinkEmbed.create = function (options) {
        var node = _super.create.call(this, 'button');
        node.innerText = options.text;
        node.setAttribute('data-button-form-id', options.formUuid);
        node.addEventListener('click', (function () { return options.onclick(options.text.replace(/<\/?span[^>]*>/ig, ''), options.formUuid); }));
        node.style.backgroundColor = options.color;
        if (options.invalid) {
            node.classList.add('invalid');
        }
        return node;
    };
    FormLinkEmbed.value = function (node) {
        return {
            formUuid: node.getAttribute('data-button-form-id'),
            text: node.innerText,
            onclick: node.onclick,
            color: node.style.backgroundColor,
        };
    };
    FormLinkEmbed.blotName = 'FormLinkEmbed';
    FormLinkEmbed.className = 'ql-form-button';
    FormLinkEmbed.tagName = 'button';
    return FormLinkEmbed;
}(embed));
export { FormLinkEmbed };
